module.exports = __webpack_public_path__ + "img/new_index_news_bg.dfdffed1.jpg";